import { jsx } from "react/jsx-runtime";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { validateTidalLicense } from "../../base/index.js";
function AddCircle(props) {
  return /* @__PURE__ */ jsx(
    AddCircleIcon,
    {
      "data-testid": "AddCircle",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AddCircle",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
AddCircle.tidalIconMeta = {
  categories: "cancel,informative",
  name: "AddCircle"
};
validateTidalLicense();
export {
  AddCircle
};
//# sourceMappingURL=AddCircle.js.map
